import { ComposableMap, Geographies, Geography, Annotation } from "react-simple-maps";

const GEO_URL = "/india-states.json";

const DEALER_STATES = {
  "Punjab":          { color: "#0A3F22", label: "HQ" },
  "Uttar Pradesh":   { color: "#1B6B3D", label: "North" },
  "Rajasthan":       { color: "#D97706", label: "West" },
  "Maharashtra":     { color: "#7C3AED", label: "South" },
};

// Approximate label coordinates [lon, lat]
const STATE_LABEL_POS = {
  "Punjab":         [74.8, 31.1],
  "Uttar Pradesh":  [80.5, 27.0],
  "Rajasthan":      [73.5, 26.5],
  "Maharashtra":    [76.5, 19.7],
};

export default function IndiaMap() {
  return (
    <div className="w-full" style={{ maxWidth: 380 }}>
      <ComposableMap
        projection="geoMercator"
        projectionConfig={{ scale: 1000, center: [82, 23] }}
        width={380}
        height={460}
        style={{ width: "100%", height: "auto" }}
      >
        <Geographies geography={GEO_URL}>
          {({ geographies }) =>
            geographies.map((geo) => {
              const name = geo.properties.ST_NM;
              const dealer = DEALER_STATES[name];
              return (
                <Geography
                  key={geo.rsmKey}
                  geography={geo}
                  fill={dealer ? dealer.color : "#D4E6D4"}
                  stroke="#FFFFFF"
                  strokeWidth={0.5}
                  style={{
                    default: { outline: "none", opacity: dealer ? 1 : 0.7 },
                    hover:   { outline: "none", fill: dealer ? dealer.color : "#BDD8BD", opacity: 1 },
                    pressed: { outline: "none" },
                  }}
                />
              );
            })
          }
        </Geographies>

        {/* State labels */}
        {Object.entries(STATE_LABEL_POS).map(([name, [x, y]]) => {
          const dealer = DEALER_STATES[name];
          if (!dealer) return null;
          return (
            <Annotation
              key={name}
              subject={[x, y]}
              dx={0}
              dy={0}
              connectorProps={{ stroke: "none" }}
            >
              <circle r={6} fill={dealer.color} opacity={0.92} />
            </Annotation>
          );
        })}
      </ComposableMap>

      {/* Legend */}
      <div className="flex flex-wrap gap-2 justify-center mt-2 px-2">
        {Object.entries(DEALER_STATES).map(([name, d]) => (
          <div key={name} className="flex items-center gap-1.5">
            <div className="w-3 h-3 rounded-sm flex-shrink-0" style={{ backgroundColor: d.color }} />
            <span className="text-xs font-semibold" style={{ color: "#1A1C1A" }}>{name}</span>
          </div>
        ))}
      </div>
    </div>
  );
}
